let obj = {
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    image: '',
    role: ''
}
export default obj;